(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxGroupWorkstations(
    GroupListService, WorkstationListPOSTPaging, WorkstationListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        group: '=group',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/groupProperties/groupWorkstations/groupWorkstations.template.html',
      link: function(scope) {

        scope.workstationPaging = new WorkstationListPOSTPaging();
        scope.noDataMessage = 'NoSearchResultComputer';
        scope.searchInputPlaceholderText = 'SearchComputerByName';

        (function() {
          getComputers();
        })();

        function getComputers () {
          scope.workstationPaging.pagingCriteria.groups = [scope.group.info._links.self.href];
          scope.workstationPaging.pagingCriteria.networkFilters = null;

          WorkstationListService.postGetWorkstationListPaged(scope.workstationPaging).then(function(response) {
            scope.workstationContainer = response;
          }).catch(function(error) {
          });
        }

        scope.getNextWorkstationPage = function(showPrevious) {
          if (showPrevious) {
            if (scope.workstationPaging.pagingCriteria.page > 0) {
              scope.workstationPaging.pagingCriteria.page--;
            }
          } else {
            if (scope.workstationPaging.pagingCriteria.page + 1 < scope.workstationContainer.page.totalPages) {
              scope.workstationPaging.pagingCriteria.page++;
            }
          }
          getComputers();
        }

        scope.getComputers = function () {
          getComputers()
        }


      }
    };
  }

  pxGroupWorkstations.$inject = ['GroupListService', 'WorkstationListPOSTPaging', 'WorkstationListService'];

  angular
    .module('printix-admin')
    .directive('pxGroupWorkstations', pxGroupWorkstations);

})();
